import { formatDateWithOptionsBs, formatTimeWithOptionsBs } from "@/lib/format";

export function parseSpecializations(raw: string): string[] {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function formatDateShort(iso: string): string {
  return formatDateWithOptionsBs(iso, {
    month: "short",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}

export function formatTime(iso: string): string {
  return formatTimeWithOptionsBs(iso, {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Sarajevo",
  });
}
